'use client';

import { CSSProperties, ComponentPropsWithoutRef } from 'react';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import { Container } from '..';
import { PrimaryButton } from './styleConstants';
import styles from './ImageTitleCtaSection.module.css';
import useIsCnOPlus from 'hooks/pricing/useIsCnOPlus';

// const imgOvulationDetectionCards =
//   'http://localhost:3845/assets/88c15f7add8431b77766ff57415f015e6e62c9e2.png';

const DownloadButton = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'button'>) => (
  <PrimaryButton
    className={`light ${styles.downloadButton}${
      className ? ` ${className}` : ''
    }`}
    {...props}
  />
);

export function ImageTitleCtaSection() {
  const { getValue } = useIsCnOPlus();

  const bgImage = getCompressedAssetUrl(
    getValue(
      '/web_v2/womens-health/illustration/monthly-report-desktop-v3.png/w_3840',
      '/web_v2/womens-health/plus/report/desktop.png/w_3840',
    ),
  );
  const bgImageResponsive = getCompressedAssetUrl(
    getValue(
      '/web_v2/womens-health/illustration/monthly-report-responsive-v3.png/w_1920',
      '/web_v2/womens-health/plus/report/mobile.png/w_1920',
    ),
  );

  return (
    <section className={styles.sectionContainer}>
      <div
        className={styles.backgroundImage}
        style={
          {
            '--bg-image': `url('${bgImage}')`,
            '--bg-image-responsive': `url('${bgImageResponsive}')`,
          } as CSSProperties
        }
      />
      <Container>
        <div className={styles.contentWrapper}>
          <h2 className={styles.title}>
            {/* A complete view of your
            <span className="subtitle">
              cycle health and patterns over time
            </span> */}
            A complete view of your cycle health{' '}
            <span className={styles.subtitle}>over time</span>
            {/* <span className="subtitle">Monthly cycle reports</span> */}
          </h2>
          <DownloadButton
            onClick={() => {
              const link = document.createElement('a');
              link.href = getValue(
                'https://s3.us-east-1.amazonaws.com/public-web-assets.uh-static.com/web_v2/womens-health/documents/C&O_Pro_Sample Report.pdf',
                'https://s3.us-east-1.amazonaws.com/public-web-assets.uh-static.com/web_v2/womens-health/plus/documents/C&O_Plus_Sample_Report.pdf',
              );
              link.download = getValue(
                'C&O Pro Sample Report.pdf',
                'C&O Plus Sample Report.pdf',
              );
              link.target = '_blank';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Download sample report
          </DownloadButton>
        </div>
      </Container>
    </section>
  );
}
